export function EmptyTableMessage({ message }: { message: string }) {
  return <p className={"py-8 text-center text-sm text-slate-500"}>{message}</p>;
}
